import {
    createIcons,
    ArrowRight,
    FilterX,
    CircleUser,
    Calendar1,
    Search,
    Check,
    MoveLeft,
    Phone,
    Mail,
    CreditCard,
    ReceiptText,
    ChevronDown,
    LibraryBig,
    UsersRound,
    GraduationCap,
    Handshake,
    SquareArrowOutUpRight,
    ChevronsRight,
    MapPin,
    Menu,
    Dot,
    Quote,
    Eye,
    Gem,
    Goal,
    X
} from 'lucide';

export const icons = {
    ArrowRight,
    FilterX,
    CircleUser,
    Calendar1,
    MoveLeft,
    Search,
    Check,
    Phone,
    Mail,
    CreditCard,
    ReceiptText,
    ChevronDown,
    LibraryBig,
    UsersRound,
    GraduationCap,
    Handshake,
    SquareArrowOutUpRight,
    ChevronsRight,
    MapPin,
    Menu,
    Dot,
    Quote,
    Eye,
    Gem,
    Goal,
    X
};

// Export initialization function
export const initIcons = () => {
    createIcons({ icons });
};